const getters = {
  allType: state => state.allType,
  oneType: state => state.oneType,
  travleBanner: state => state.travleBanner,
  travleSec: state => state.travleSec,
  travleList: state => state.travleList,
  marketList: state => state.marketList,
  marketDetail: state => state.marketDetail,
  marketGoodsList: state => state.marketGoodsList,
  changeTravleType: state => state.changeTravleType.changeTravleType,
  changeMarketType: state => state.changeMarketType,
  changeUserMarketType: state => state.changeUserMarketType,
  changeEducation: state => state.changeEducation,
  mutualLove: state => state.mutualLove,
  mutualLove1: state => state.mutualLove1,
  mutualLovenum: state => state.mutualLovenum,
  chosenum: state => state.chosenum,
  mutinid: state => state.mutinid,
  mutualLoveJS: state => state.mutualLoveJS,
  area: state => state.changeTravleType.area,
  areaChoose: state => state.changeTravleType.areaChoose,
  travleDetail: state => state.travleDetail,
  travleDetailRecommend: state => state.travleDetailRecommend,
  marketDetailRecommend: state => state.marketDetailRecommend,
  travleDetailJ: state => state.travleDetailJ,
  travleDetailR: state => state.travleDetailR,
  travleDetailNav: state => state.travleDetailNav,
  nearbyScenic: state => state.nearbyScenic,
  houseData: state => state.houseData,
  idleData: state => state.idleData,
  logisticsData: state => state.logisticsData,
  sameType: state => state.sameType,
  getSameCateInfo: state => state.info
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js